<ng-container *transloco="let t">
  <div class="row mb-1" *ngFor="let v of values$ | async">
    <div class="col-12">
      <span class="mr-2">{{v.question}}:</span> <span class="font-weight-bold text-uppercase">{{v.answer ?
        t('common.yes') : t('common.no')}}</span>
    </div>
  </div>
</ng-container>
